import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SocialButton = ({ brand, hasBrandColor, onClick, disabled }) => {
  const classes = classNames({
    'social-button': true,
    [`social-button__${brand}`]: hasBrandColor,
    'social-button--no-brand-color': !hasBrandColor,
    'social-button--disabled': disabled,
  });
  return (
    <button
      aria-label={brand}
      className={classes}
      title={brand}
      type="button"
      onClick={onClick}
    >
      <span className={`icon icon-${brand}`} />
    </button>
  );
};

SocialButton.propTypes = {
  brand: PropTypes.oneOf(['facebook', 'twitter', 'tumblr', 'youtube', 'instagram', 'mail']).isRequired,
  disabled: PropTypes.bool,
  hasBrandColor: PropTypes.bool,
  onClick: PropTypes.func,
};

SocialButton.defaultProps = {
  onClick: () => {},
  disabled: false,
  hasBrandColor: true,
};

export default SocialButton;
